// ─── Shared sentinel types & predicates ────────────────────────────────────
// Sentinels are non-data rows injected into virtualized lists for special UI
// items (placeholder, group headers, select-all). They carry no `.id` field
// and must never be counted toward real data totals.

export interface PlaceholderSentinel {
  __placeholder: true;
  label: string;
}

export function makePlaceholderSentinel(label: string): PlaceholderSentinel {
  return { __placeholder: true, label };
}

export function isPlaceholderSentinel(v: unknown): v is PlaceholderSentinel {
  return typeof v === "object" && v !== null && "__placeholder" in v;
}

export interface CreatableSentinel {
  __creatable: true;
  label: string;
}

export function makeCreatableSentinel(label: string): CreatableSentinel {
  return { __creatable: true, label };
}

export function isCreatableSentinel(v: unknown): v is CreatableSentinel {
  return typeof v === "object" && v !== null && "__creatable" in v;
}
